import { useContext as o } from "react";
import { HoopsViewerContext as e, HoopsViewerInnerContext as t } from "./HoopsViewerContext.mjs";
const s = () => o(e), p = () => o(t);
export {
  s as useBundle,
  p as useHoopsViewerContext
};
//# sourceMappingURL=HoopsViewerContext.hooks.mjs.map
